export default __webpack_public_path__ + "static/media/construction.1e204187.JPG";